<template>
  <ElFormItem class="form-item-with-hint" v-bind="$attrs" v-on="$listeners">
    <span slot="label">
      {{ label }}
      <Hint :message="hint" />
    </span>
    <slot />
  </ElFormItem>
</template>

<script>
import Hint from './Hint';

export default {
  name: 'FormItemWithHint',
  components: {
    Hint,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.form-item-with-hint {
  .el-form-item__label {
    position: relative;
    z-index: 1;
  }
}
</style>
